import React from "react";
import Task, { taskTypes } from "components/Task";
import { getSummaryDescription } from "utils/documentSummary";

const DocumentSummaryContent = () => {
  return (
    <div className="document_summary" data-testid="document-summary">
      <span className="document_summary__title">
        {window.PageObject.docName}
      </span>
      <span className="document_summary__description">
        {getSummaryDescription(
          window.PageObject.creationDate,
          window.PageObject.username
        )}
      </span>
      <span className="document_summary__common_tasks">
        Common Document Tasks
      </span>
      <div className="document_summary__task_list">
        <Task
          type={taskTypes.discovery}
          args={{
            docSetId: window.PageObject.docSetId,
            docId: window.PageObject.docId,
          }}
        />
        <Task
          type={taskTypes.dictionarySearch}
          args={{
            docSetId: window.PageObject.docSetId,
            docId: window.PageObject.docId,
          }}
        />
        <Task
          type={taskTypes.simpleShred}
          args={{
            docSetId: window.PageObject.docSetId,
            docId: window.PageObject.docId,
          }}
        />
        <Task
          type={taskTypes.viewReadabilityScores}
          args={{
            docSetId: window.PageObject.docSetId,
            docId: window.PageObject.docId,
          }}
        />
        <Task type={taskTypes.compareExcel} />
        <Task type={taskTypes.compareDocuments} />
        <Task
          type={taskTypes.extractAcronyms}
          args={{
            docSetId: window.PageObject.docSetId,
            docId: window.PageObject.docId,
          }}
        />
        <Task
          type={taskTypes.categoryShred}
          args={{
            docSetId: window.PageObject.docSetId,
            docId: window.PageObject.docId,
          }}
        />
      </div>
    </div>
  );
};

export default DocumentSummaryContent;
